// Fan Intelligence System — client-side tracking
const STORAGE_KEY = 'at_fan_profile';

function getProfile() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || createProfile();
  } catch { return createProfile(); }
}

function createProfile() {
  return {
    filmsViewed: [], trailersPlayed: [], platformClicks: { netflix: 0, prime: 0, youtube: 0 },
    dwellTime: 0, scrollDepth: 0, totalInteractions: 0,
    insideData: { name: '', email: '', gender: '', city: '', ageRange: '', phone: '', interests: [] },
    rsvps: 0, insideCompleted: false, firstVisit: new Date().toISOString(), lastVisit: new Date().toISOString(),
  };
}

function save(profile) {
  profile.lastVisit = new Date().toISOString();
  localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
}

export function trackFilmView(title) {
  const p = getProfile();
  if (!p.filmsViewed.includes(title)) p.filmsViewed.push(title);
  p.totalInteractions++;
  save(p);
}

export function trackTrailerPlay(title) {
  const p = getProfile();
  if (!p.trailersPlayed.includes(title)) p.trailersPlayed.push(title);
  p.totalInteractions++;
  save(p);
}

export function trackPlatformClick(platform) {
  const p = getProfile();
  if (p.platformClicks[platform] !== undefined) p.platformClicks[platform]++;
  p.totalInteractions++;
  save(p);
}

export function trackRsvp() {
  const p = getProfile();
  p.rsvps++;
  p.totalInteractions++;
  save(p);
}

export function updateInsideData(data) {
  const p = getProfile();
  p.insideData = { ...p.insideData, ...data };
  if (data.interests || data.ageRange) p.insideCompleted = true;
  p.totalInteractions++;
  save(p);
}

export function updateDwell(seconds) {
  const p = getProfile();
  p.dwellTime = seconds;
  save(p);
}

export function updateScrollDepth(pct) {
  const p = getProfile();
  if (pct > p.scrollDepth) p.scrollDepth = pct;
  save(p);
}

export function getFanScore() {
  const p = getProfile();
  return p.filmsViewed.length * 10 + p.trailersPlayed.length * 15
    + (p.platformClicks.netflix + p.platformClicks.prime + p.platformClicks.youtube) * 5
    + Math.floor(p.dwellTime / 10) + (p.insideCompleted ? 50 : 0) + p.rsvps * 20;
}

export function getFanTemperature() {
  const p = getProfile();
  const i = p.totalInteractions;
  if (i >= 16) return 'Superfan';
  if (i >= 9) return 'Hot';
  if (i >= 4) return 'Warm';
  return 'Cold';
}

export function getFullProfile() { return getProfile(); }

export function exportProfile() {
  const p = getProfile();
  const blob = new Blob([JSON.stringify({ ...p, fanScore: getFanScore(), fanTemperature: getFanTemperature() }, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a'); a.href = url; a.download = 'fan-profile.json'; a.click();
  URL.revokeObjectURL(url);
}
